import { useState } from 'react';
import { Col, Container, Row, Tab, Tabs } from 'react-bootstrap';
import DevicePolicy from './devicePolicy/DevicePolicy';
import MiscSettings from './misc/MiscSettings';
import { useAuth } from '../hooks/useAuth';
import CustomPrompts from './customPrompts/CustomPrompts';

function MenuTabs() {
  const [key, setKey] = useState('devicePolicy');
  const data = useAuth();

  if (!data || !data.tenant) {
    return null;
  }

  return (
    <Tabs
      id="controlled-tab-example"
      activeKey={key}
      onSelect={(k) => setKey(k)}
    >
      <Tab eventKey="devicePolicy" title="Device Policy">
        <Container>
          <Row>
            <Col>
              <DevicePolicy tenant={data.tenant} />
            </Col>
          </Row>
        </Container>
      </Tab>
      <Tab eventKey="customPrompts" title="Custom IVR Prompts">
        <Container fluid>
          <Row>
            <Col>
              <CustomPrompts />
            </Col>
          </Row>
        </Container>
      </Tab>
      <Tab eventKey="misc" title="Miscellaneous">
        <Container>
          <Row>
            <Col>
              <MiscSettings />
            </Col>
          </Row>
        </Container>
      </Tab>
    </Tabs>
  );
}

export default MenuTabs;
